module.exports = require('../../../../node_modules/nodebb-plugin-markdown/public/js/markdown.js');